// import Logo from "shared/Logo/Logo";
// import SocialsList1 from "shared/SocialsList1/SocialsList1";
import { CustomLink } from "data/types";
import React from "react";
import Label from "components/Label/Label";
import Input from "shared/Input/Input";
import Textarea from "shared/Textarea/Textarea";
import { SocialType } from "shared/SocialsShare/SocialsShare";
import instagram from "images/instagram.png";
import facebook from "images/facebook.png";
import linkedin from "images/linkedin.png";

export interface WidgetFooterMenu {
  id: string;
  title: string;
  menus: CustomLink[];
}

const Footer2: React.FC = () => {
  
  const socialsDemo: SocialType[] = [
    { name: "Facebook", icon: facebook, href: "#" },
    { name: "Linkedin", icon: linkedin, href: "#" },
    { name: "Instagram", icon: instagram, href: "#" },
  ];
  

  return (
    <div className="flex flex-row relative    ">
     <div className=" flex-col min-w-[360px] md:min-w-[460px]  h-[800px] ">
      
           {/* <div className="flex flex-row relative  w-full h-full"> */}
             {/* <div className=" flex flex-col relative"> */}
                {/* <div className="  flex-col   w-full h-full"> */}
                     <div className="ml-[50px] h-[3px]  bg-[#19CFD8] "></div>
                     <div className="ml-[50px] h-[700px] rounded-b-md bg-[white]">
                     <div className=" px-8  text-neutral-700  ">
                        <h2 className="text-3xl font-bold pt-[20px] ">
                          <span >Get in touch</span>
                        </h2>
                              <div>
                                    <form className="grid grid-cols-1 gap-6" >
                                      <label className="block pt-[20px]">
                                        <Label>Name</Label>

                                        <Input
                                          placeholder="Type your full name"
                                          type="text"
                                          className="mt-1 rounded-md"
                                        />
                                      </label>
                                      <label className="block">
                                        <Label>Email </Label>

                                        <Input
                                          type="email"
                                          placeholder="example@example.com"
                                          className="mt-1 rounded-md"
                                        />
                                      </label>
                                      <label className="block">
                                        <Label>Phone </Label>

                                        <Input
                                          type="text"
                                          placeholder="example@example.com"
                                          className="mt-1 rounded-md"
                                        />
                                      </label>
                                      <label className="block">
                                        <Label>How do you hear about us? </Label>

                                        <Input
                                          type="email"
                                          placeholder="example@example.com"
                                          className="mt-1 rounded-md"
                                        />
                                      </label>
                                      <label className="block">
                                        <Label>Message</Label>

                                        <Textarea className="mt-1" rows={4} />
                                      </label>
                                      <div>
                                        <button className="p-3 text-white font-medium  rounded-lg w-full bg-[#00D3DB]" type="submit">Send</button>
                                      </div>
                                    </form>
                               </div>
                        </div>
                     </div>
                {/* </div> */}
                {/* <div className="  flex-col w-1/4 bg-[green] h-[550px]">
                  
                </div> */}
             {/* </div> */}
           {/* </div> */}
     </div>
     <div className="hidden md:block  flex-col w-full h-[700px] ">
        <div className={`pl-[20px] flex-grow h-full pt-[628px]`}>
              <div className={`flex space-x-2.5 text-4xl`}>
                    {socialsDemo.map((item, i) => (
                      <a
                        key={i}
                        className="block text-white"
                        href={item.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        title={item.name}
                      >
                        <img src={item.icon} className="w-10" alt="" />
                        {/* <i className={item.icon}></i> */}
                      </a>
                    ))}
              </div>
                <div className="text-xs flex flex-col text-white ">
                    <span >@Copyright GEP 2023 All Rights reserved.</span>
                    <span >Sitemap | Terms of Use | Privacy Statement </span>
                </div>
        </div> 
     </div>
     {/* <div className=" flex-col w-1/3  h-[550px] ">

     </div> */}
    </div>
  );
};

export default Footer2;